import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchTenantSettings, updateTenantSettings } from '@/services/tenant-settings';
import type { UpdateTenantSettingsInput } from '@/types/tenant-settings';

const TENANT_SETTINGS_KEY = ['admin', 'tenant', 'settings'];

export function useTenantSettings() {
  return useQuery({
    queryKey: TENANT_SETTINGS_KEY,
    queryFn: fetchTenantSettings,
  });
}

export function useUpdateTenantSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateTenantSettingsInput) => updateTenantSettings(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TENANT_SETTINGS_KEY });
    },
  });
}
